import { render, staticRenderFns } from "./saisiyun.vue?vue&type=template&id=55683314"
import script from "./saisiyun.vue?vue&type=script&lang=js"
export * from "./saisiyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports